export default "__VITE_ASSET__C69oNIT5__"